import { z } from 'zod/v4';

export const DefaultRecoveryPlanSchema = z.object({
  recoveryPlanId: z.string().nullable(),
});
